import { useCallback, useMemo, useRef } from 'react';
import '../Analitos.scss';
import DataGrid, { Column, Button as Butt, Editing, Popup as Pop, Lookup, Item as ItemT, RequiredRule, Form, Toolbar, Scrolling } from 'devextreme-react/data-grid';
import { useApiConfiguration } from '../../../api/api.configuration';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { Item } from 'devextreme-react/form';
import { Tooltip } from 'devextreme-react';
import Button from 'devextreme-react/button';

export const SamplesTypes = ({ dataMuestras, update }) => {
  const dataRef = useRef<DataGrid>(null);
  const { newSampleType, setSampleType, deleteSampleType } = useApiConfiguration();

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Tm_Id',
      load() {
        return Promise.resolve({
          data: dataMuestras,
        }).catch(() => {
          throw new Error('Error de carga de datos');
        });
      },
      insert: async (values) => {
        return newSampleType({ TipoMuestra: values })
          .then((res) => {
            if (res === 105) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el tipo de muestra');
          });
      },
      update: (key, values) => {
        return setSampleType({ TipoMuestra: values, IdTipoMuestra: key })
          .then((res) => {
            if (res === 107) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error actualizando el tipo de muestra');
          });
      },
      remove: (key) => {
        return deleteSampleType({ IdTipoMuestra: key }).then((res) => {
          if (res === 107) {
            dataRef.current?.instance.refresh();
          }
        });
      },
    });
  }, [dataMuestras]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  //Renderiza la celda de muestras
  const handleSample = useCallback((cellData) => {
    const { data } = cellData;
    return (
      <div className='tube-container' id={`tmSample${data.Tm_Id}`} key={data.Tm_Id}>
        <div className='test-tube'>
          <div className='liquid' style={{ backgroundColor: data.Tm_Color || '#888' }}></div>
        </div>
      </div>
    );
  }, []);

  const handleRefresh = useCallback(() => {
    update();
  }, [update]);

  return (
    <div>
      <DataGrid dataSource={customDataSrc} ref={dataRef}>
        <Scrolling useNative={false} showScrollbar="always" />
        <Editing mode='form' allowUpdating={true} allowAdding={true} allowDeleting={true} selectTextOnEditStart={true}>
          <Form>
            <Item dataField='Tm_Color' editorType='dxColorBox' />
            <Item dataField='Tm_Nombre' />
            <Item dataField='Tm_Descripcion' />
            <Item dataField='Tm_Sufijo' />
            <Item dataField='Tm_TiempoDescarte' />
            <Item dataField='Tm_Estado' editorType='dxCheckBox' />
          </Form>
        </Editing>
        <Toolbar>
          <ItemT name='addRowButton' />
          <ItemT location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
            <Button id='RefrecarResultsa' icon='refresh' text='Refresh' stylingMode='text' onClick={handleRefresh} />
            <Tooltip target={'#RefrecarResultsa'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
              Refrescar datos
            </Tooltip>
          </ItemT>
        </Toolbar>
        <Column allowGrouping={false} caption='COLOR' dataField='Tm_Color' alignment='center' cellRender={handleSample} visible={true} allowEditing={true} width={100} minWidth={80}>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='MUESTRA' visible={true} allowEditing={true} dataField='Tm_Nombre' alignment='center' width={150} minWidth={120}>
          <RequiredRule />
        </Column>
        <Column allowGrouping={false} caption='DESCRIPCIÓN' visible={true} allowEditing={true} dataField='Tm_Descripcion' alignment='center' width={200} minWidth={150} />
        <Column allowGrouping={false} caption='SUFIJO' visible={true} allowEditing={true} dataField='Tm_Sufijo' alignment='center' width={100} minWidth={80} />
        <Column dataType='number' allowGrouping={false} caption='TIEMPO DESCARTE' visible={true} allowEditing={true} dataField='Tm_TiempoDescarte' alignment='center' width={150} minWidth={120} />
        <Column dataType='boolean' allowGrouping={false} caption='ESTADO' visible={true} allowEditing={true} dataField='Tm_Estado' alignment='center' width={100} minWidth={80}>
          <RequiredRule />
        </Column>
        <Column type='buttons' caption={'ACCIÓN'} width={120} minWidth={100}>
          <Butt name='edit' />
          <Butt name='delete' />
        </Column>
      </DataGrid>
    </div>
  );
};
